module.exports = __webpack_public_path__ + "img/98.4.187f8079.png";